export { default as AuthenticationPage } from './AuthenticationPage/AuthenticationPage';
export { default as ContactDetailsPage } from './ContactDetailsPage/ContactDetailsPage';
export { default as YourListingsPage } from './YourListingsPage/YourListingsPage';
export { default as EmailVerificationPage } from './EmailVerificationPage/EmailVerificationPage';
export { default as NotFoundPage } from './NotFoundPage/NotFoundPage';
export { default as PasswordChangePage } from './PasswordChangePage/PasswordChangePage';
export { default as PasswordRecoveryPage } from './PasswordRecoveryPage/PasswordRecoveryPage';
export { default as PasswordResetPage } from './PasswordResetPage/PasswordResetPage';
export { default as PrivacyPolicyPage } from './PrivacyPolicyPage/PrivacyPolicyPage';
export { default as ProfileSettingsPage } from './ProfileSettingsPage/ProfileSettingsPage';
export { default as StaticPage } from './StaticPage/StaticPage';
export { default as TermsOfServicePage } from './TermsOfServicePage/TermsOfServicePage';
export { default as TopbarContainer } from './TopbarContainer/TopbarContainer';
export { default as Paisajes } from './Paisajes/Paisajes';
export { default as Personas } from './Personas/Personas';
export { default as BusinessPage } from './BusinessPage/BusinessPage';
export { default as AlliesPage } from './AlliesPage/AlliesPage';
export { default as UpdateCardPage } from './UpdateCardPage/UpdateCardPage';
export { default as FaqsPage } from './FaqsPage/FaqsPage';
export { default as PaymentHistoryPage } from './PaymentHistoryPage/PaymentHistoryPage';
export { default as PersonalFootprintCalculatorPage } from '../newPages/PersonalFootprintCalculatorPage/PersonalFootprintCalculatorPage';
export { default as LandscapePage } from './ListingPage/Landscape';
export { default as ActionPage } from './ListingPage/Action';
export { default as NewActionPage } from './NewActionPage/NewActionPage';
export { default as NewProfilePage } from './ProfilePage/NewProfilePage';